export class LegalEntityLocation {
  country: string;
  description: string;
  lat: number;
  lng: number;
}
